module.exports = __webpack_public_path__ + "static/media/veneto-village-29.b521319d.jpg";